import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BehavioralRangesRectanglesComponent } from './BehavioralRangesRectangles.component';

export const BehavioralRangesRectanglesModuleExports = [
    BehavioralRangesRectanglesComponent
];

@NgModule({
    imports: [CommonModule],
    declarations: [...BehavioralRangesRectanglesModuleExports],
    exports: [...BehavioralRangesRectanglesModuleExports],
    providers: []
})
export class BehavioralRangesRectanglesModule {}
